import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  SimpleChanges,
  ViewChild
} from "@angular/core";
import { fuseAnimations } from "@fuse/animations";
import { HelperService } from "app/helpers/helper.service";

@Component({
  selector: "app-simple-card",
  templateUrl: "./simple-card.component.html",
  styleUrls: ["./simple-card.component.scss"],
  animations: fuseAnimations,
})
export class SimpleCardComponent implements OnInit, AfterViewInit {
  @ViewChild("extra_container", { read: ElementRef })
  extra_container: ElementRef;
  @ViewChild("footer", { read: ElementRef })
  footer_container: ElementRef;
  @ViewChild("sub_title", { read: ElementRef })
  sub_title: ElementRef;

  public disableCard: boolean = false


  private isViewInit = false;
  public card_title: string = "";
  private _extra_title: string;
  public hideIt = false;
  public showPlaceHolder = false;
  public card_color = "";
  public card_color_palette = "accent";
  private _callback = null;
  private _showFooter = false;
  private _showTableButton = false;
  private extraContainerHtml = "";

  public showEditBtn = false;
  public showDeleteBtn = false;
  public showMoveBtn = false;
  public _showShareButton = false;
  public showVoteBtn = false;
  public showCopyBtn = false;
  public showMoreBtn = false;
  public showDeactivateBtn = false;
  public showWardEditBtn = false;
  public showWardDeleteBtn = false;
  private _onClickTableButton = () => { };
  public onClickEditBtn = () => { };
  public onClickMoveBtn = () => { };
  public onClickDeleteBtn = () => { };
  public onClickCopyBtn = () => { };
  public onClickShareButton = () => { };
  public onVoteButtonClick = () => { };
  public onClickMoreButton = () => { };
  public onClickDeactivateButton = () => { };
  public onClickWardEditBtn = () => { };
  public onClickWardDeleteBtn = () => { };

  parameters: any;
  get callback() {
    return this._callback;
  }

  set callback(v: any) {
    this._callback = v;
  }

  public afterViewInit = () => {
    if (this.disableCard) {
      this.card_color_palette = "primary-100"
    }
  };

  set extra_title(value: string) {
    this._extra_title = value;
  }

  get extra_title() {
    return this._extra_title;
  }

  public get showFooter(): boolean {
    return this._showTableButton || this._showShareButton || this.showVoteBtn;
  }

  public get onClickTableButton(): any {
    return this._onClickTableButton;
  }

  public set onClickTableButton(v: any) {
    this._onClickTableButton = v;
  }
  public get showTableButton(): boolean {
    return this._showTableButton;
  }

  public set showTableButton(v: boolean) {
    this._showTableButton = v;
  }

  constructor(
    public renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private helper: HelperService
  ) {
    this.extra_title = "";
    this.card_color = helper.getRandomColor(7);
  }

  ngOnInit(): void { }

  ngAfterViewInit(): void {
    this.afterViewInit();
    this.isViewInit = true;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  onCardClick(): any {
    this.callback();
  }

  setAsPlaceHolder(): void {
    this.hideIt = true;
    this.showPlaceHolder = true;
  }

  addExtraContainerElements(html: string): void {
    // this.extra_container.nativeElement.innerHTML = html;
    this.extraContainerHtml = html;
  }

  ngOnChanges(changes: SimpleChanges): void { }

  hideExtraContainer() {
    if (!this.isViewInit) return false;
    else
      return (
        !this.extra_container ||
        this.extra_container.nativeElement.innerHTML == ""
      );
  }

  getExtraContainerHtml(): string {
    if (this.extra_container)
      return this.extra_container.nativeElement.innerHTML;
    return "";
  }

  clickTableBtn = () => {
    if (this.onClickTableButton) {
      this.onClickTableButton();
    }
  };
}
